import { useQuery } from '@tanstack/react-query';
import { fetchAllSuppliers } from '../../DirectoriesPage/SuppliersPage/services';
import { useWarehouses } from '../../shared/useWarehouses';
import {
  fetchIncomeDocumentTypes,
  fetchWarehouseDocumentStatuses,
} from '../services';

export const useWarehouseIncomesData = () => {
  const { data: types } = useQuery({
    queryKey: ['income-warehouse-document-types'],
    queryFn: fetchIncomeDocumentTypes,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const { data: statuses } = useQuery({
    queryKey: ['warehouse-document-statuses'],
    queryFn: fetchWarehouseDocumentStatuses,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const { data: suppliers } = useQuery({
    queryKey: ['suppliers', 'all'],
    queryFn: () => fetchAllSuppliers(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const { warehouses } = useWarehouses();

  return { types, statuses, warehouses, suppliers };
};
